/*
Обязательные классы и атрибуты: i-textarea
Опционально _autoresize: тогда текстареа будет растягиваться и ужиматься до дефлнтного значения rows="1"

-----------------------------------------
Пример:
<textarea class="i-textarea _autoresize" rows="1" placeholder="Растягивающаяся текстареа"></textarea>

-----------------------------------------
Для позиционирования и кастомизации обернуть в контейнер
*/

(function () {
    $ (function () {
        
        function init (element) {
            if (element.classList.contains ('_autoresize')) {
                const offset = element.offsetHeight - element.clientHeight;
                
                element.classList.remove ('_autoresize');
                
                element.addEventListener ('input', event => {
                    element.style.height = 'auto';
                    element.style.height = element.scrollHeight + offset + 'px';
                });
            }
            
            element.addEventListener ('focus', event => {
                const wrap = element.closest ('.i-textarea-wrap');
                
                if (wrap) {
                    wrap.classList.add ('_focused');
                }
            });
            
            element.addEventListener ('blur', event => {
                const wrap = element.closest ('.i-textarea-wrap');
                
                if (wrap) {
                    wrap.classList.remove ('_focused');
                }
            });
        }
        
        document.querySelectorAll ('.i-textarea').forEach (element => {
            init (element);
        });
        
        document.addEventListener ('ab.i-textarea.init', event => {
            let wrap = document;
            
            if (event.detail.wrap) {
                wrap = event.detail.wrap;
            }
            
            wrap.querySelectorAll ('.i-textarea').forEach (element => {
                init (element);
            });
        });
    })
} ());
